import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faGlobe, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/HeaderTop.css';

function HeaderTop() {
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const headerHeight = document.querySelector('.bg-top').offsetHeight;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    };

    const navigateToWithAnchor = (id) => {
        const currentPath = window.location.pathname;

        if (currentPath !== '/') {
            // Stocke l'ancre dans `sessionStorage` pour l'utiliser après la redirection
            sessionStorage.setItem('scrollToAnchor', id);
            window.location.href = '/'; // Redirige vers la page d'accueil
        } else {
            scrollToSection(id); // Déclenche le scroll directement
        }
    };

    // Détecte si une ancre doit être scrollée après la redirection
    React.useEffect(() => {
        const anchor = sessionStorage.getItem('scrollToAnchor');
        if (anchor) {
            scrollToSection(anchor); // Scroll vers l'ancre
            sessionStorage.removeItem('scrollToAnchor'); // Supprime l'ancre après l'avoir utilisée
        }
    }, []);

    const navigateTo = (url, isExternal = false) => {
        if (isExternal) {
            window.open(url, '_blank', 'noopener,noreferrer'); // Ouvre dans un nouvel onglet
        } else {
            window.location.href = url; // Navigation interne
        }
    };

    return (
        <div className="bg-top text-white py-2">
            <div className="container">
                <div className="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap">
                    {/* Liens sur mobile : Répartis uniformément */}
                    <div className="d-flex w-100 justify-content-around d-md-none">
                        <button
                            onClick={() => navigateTo('/actualites')}
                            className="d-flex flex-column align-items-center text-white text-decoration-none bg-transparent border-0"
                        >
                            <FontAwesomeIcon icon={faNewspaper} className="mb-1 header-top-icon" />
                            <span className="small">Actualités</span>
                        </button>
                        <button
                            onClick={() => navigateTo('https://www.croixblanche.org/', true)}
                            className="d-flex flex-column align-items-center text-white text-decoration-none bg-transparent border-0"
                        >
                            <FontAwesomeIcon icon={faGlobe} className="mb-1 header-top-icon" />
                            <span className="small">Site Fédéral</span>
                        </button>
                        <button
                            onClick={() => navigateToWithAnchor('nous-trouver')}
                            className="d-flex flex-column align-items-center text-white text-decoration-none bg-transparent border-0"
                        >
                            <FontAwesomeIcon icon={faLocationDot} className="mb-1 header-top-icon" />
                            <span className="small">Nous trouver</span>
                        </button>
                    </div>

                    {/* Liens sur PC : Groupés à droite */}
                    <div className="d-none d-md-flex justify-content-end gap-3 w-100">
                        <button
                            onClick={() => navigateTo('/actualites')}
                            className="d-flex align-items-center text-white text-decoration-none bg-transparent border-0"
                        >
                            <FontAwesomeIcon icon={faNewspaper} className="me-2 header-top-icon" />
                            <span>Actualités</span>
                        </button>
                        <button
                            onClick={() => navigateTo('https://www.croixblanche.org/', true)}
                            className="d-flex align-items-center text-white text-decoration-none bg-transparent border-0"
                        >
                            <FontAwesomeIcon icon={faGlobe} className="me-2 header-top-icon" />
                            <span>Site Fédéral</span>
                        </button>
                        <button
                            onClick={() => navigateToWithAnchor('nous-trouver')}
                            className="d-flex align-items-center text-white text-decoration-none bg-transparent border-0"
                        >
                            <FontAwesomeIcon icon={faLocationDot} className="me-2 header-top-icon" />
                            <span>Nous trouver</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderTop;
